import React from "react";
import SpacedSection from "../SpacedSection/SpacedSection";
import Campaign from "../Campaign/Campaign";
import CampaignsCarousel from "../CampaignsCarousel/CampaignsCarousel";
import styles from "./LandingPageCarousel.module.scss";
import { SanityLandingPageCarousel } from "../../model/landing-page";

interface LandingPageCarouselProps {
  value: SanityLandingPageCarousel;
}

const LandingPageCarousel = ({
  value: {
    carousel: { items: campaigns }
  }
}: LandingPageCarouselProps) => {
  if (!campaigns || campaigns.length === 0) {
    return null;
  }

  const slides = campaigns.map(campaign => (
    <Campaign
      key={campaign._id}
      className={styles.campaign}
      campaign={campaign}
      orientation="horizontal"
    />
  ));
  return (
    <SpacedSection>
      <CampaignsCarousel className={styles.campaigns}>
        {slides}
      </CampaignsCarousel>
    </SpacedSection>
  );
};

export default LandingPageCarousel;
